module.exports = __webpack_public_path__ + "static/media/image.d96d12c1.png";